import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import { compose } from 'recompose';
import useBrand from 'wfui-digital-core/es/useBrand';
import SvgIcon from 'wfui-digital-core/es/SvgIcon';
import accessibleIcon from 'wfui-digital-core/es/accessibleIcon';
import { getClasses } from 'wfui-digital-core/es/lib';
import styles from './MenuIcon.less';

var MenuIcon = function MenuIcon(_ref) {
  var active = _ref.active,
      props = _objectWithoutProperties(_ref, ["active"]);

  var brand = useBrand();
  var classNames = getClasses({
    styles: styles,
    classes: ['menuIcon', active && 'active'],
    brand: brand
  });
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 32 32",
    className: classNames
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 9.000000)",
    "data-testid": "group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "13",
    width: "22",
    height: "1",
    rx: "0.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "22",
    height: "1",
    rx: "0.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "6.5",
    width: "22",
    height: "1",
    rx: "0.5"
  }))));
};

MenuIcon.defaultProps = {
  width: '32px',
  height: '32px'
};
export default /*#__PURE__*/React.memo(compose(accessibleIcon)(MenuIcon));